var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFondoFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1512,
    height: 439,
    viewBox: "0 0 1512 439",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_91_62)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 439,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.0000915527,
    width: 1512,
    height: 439,
    fill: "#004438"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1712.1 484.115C1667.93 544.885 1582.89 558.343 1522.12 514.179L1356.12 393.539C1400.28 332.769 1485.33 319.311 1546.07 363.457L1712.07 484.097L1712.1 484.115Z",
    fill: "#33993F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1512.18 94.4454L1460.97 210.375C1441.43 254.594 1461.43 306.308 1505.67 325.868L1531.49 337.27L1582.72 221.316C1602.26 177.097 1582.26 125.383 1538.01 105.824L1512.2 94.4207L1512.18 94.4454Z",
    fill: "#DFA41A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-200.096 484.115C-155.932 544.885 -70.887 558.343 -10.1171 514.179L155.883 393.539C111.719 332.769 26.674 319.311 -34.0711 363.457L-200.071 484.097L-200.096 484.115Z",
    fill: "#33993F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.178257 94.4454L51.0313 210.375C70.5727 254.594 50.5695 306.308 6.32566 325.868L-19.4913 337.27L-70.7188 221.316C-90.2603 177.097 -70.2571 125.383 -26.0132 105.824L-0.196205 94.4207L-0.178257 94.4454Z",
    fill: "#DFA41A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_91_62"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 439,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFondoFooter);
export default __webpack_public_path__ + "static/media/fondo_footer.70bf3d98cc27acdc146f8895359d79fd.svg";
export { ForwardRef as ReactComponent };